import { render, staticRenderFns } from "./MdRead.vue?vue&type=template&id=d5895554&scoped=true&"
import script from "./MdRead.vue?vue&type=script&lang=js&"
export * from "./MdRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5895554",
  null
  
)

export default component.exports